import { useState } from "react";
import { Input } from "../ui/input";
import { Search, LifeBuoy } from "lucide-react";
import { HELP_TOPICS } from "../../lib/helpContent";

// GM-facing "Help" tab: a searchable how-to library. New topics get added here as the
// tutorial system grows — no images/video yet, just fast, honest text.
export default function GmHelpTab() {
  const [query, setQuery] = useState("");

  const filtered = HELP_TOPICS.filter((t) => {
    const haystack = `${t.title} ${t.category} ${t.body.join(" ")}`.toLowerCase();
    return haystack.includes(query.toLowerCase());
  });

  const grouped = filtered.reduce((acc, t) => {
    (acc[t.category] = acc[t.category] || []).push(t);
    return acc;
  }, {});

  return (
    <div className="space-y-3" data-testid="gm-help-tab">
      <div className="relative">
        <Search className="w-3.5 h-3.5 text-[#f1e0c5]/40 absolute left-3 top-1/2 -translate-y-1/2" />
        <Input
          data-testid="gm-help-search-input"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search how-tos…"
          className="bg-black/30 border-white/10 pl-8 text-xs h-8"
        />
      </div>

      {Object.keys(grouped).length === 0 && (
        <p className="text-xs text-[#f1e0c5]/30 italic">No how-tos match "{query}" yet.</p>
      )}

      {Object.entries(grouped).map(([category, topics]) => (
        <div key={category} className="space-y-2">
          <p className="text-[10px] uppercase text-[#f1e0c5]/40">{category}</p>
          {topics.map((t) => (
            <div key={t.id} data-testid={`gm-help-topic-${t.id}`} className="bg-black/20 rounded-lg overflow-hidden">
              {t.image && <img src={t.image} alt={t.title} className="w-full h-24 object-cover" />}
              <div className="p-3 space-y-1.5">
                <p className="text-sm text-[#D4AF37] flex items-center gap-1.5"><LifeBuoy className="w-3 h-3" /> {t.title}</p>
                <ul className="space-y-1 text-[11px] text-[#f1e0c5]/60 list-disc pl-4">
                  {t.body.map((line, i) => <li key={i}>{line}</li>)}
                </ul>
              </div>
            </div>
          ))}
        </div>
      ))}

      <p className="text-[10px] text-[#f1e0c5]/25 pt-2 border-t border-white/10">
        Look for the (i) icons next to tricky features for a quick answer right where you need it.
      </p>
    </div>
  );
}
